import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import evieLogo from 'assets/images/logo-letter.png';

const InfoScreen = ({ children, staticimg }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className={`info-screen ${staticimg ? 'staticimg' : ''}`}>
      <img src={evieLogo} alt="Evie logo" className="info-screen__logo" />
      {children}
    </section>
  );
};

InfoScreen.defaultProps = {
  staticimg: false,
};

InfoScreen.propTypes = {
  children: PropTypes.node.isRequired,
  staticimg: PropTypes.bool,
};

export default InfoScreen;
